import { Alert } from "@xola/ui-kit";
import React, { ReactNode } from "react";

interface NoResultsProps {
    children: ReactNode;
}

export const NoResults = ({ children }: NoResultsProps) => {
    return (
        <div className="mt-10 flex justify-center">
            <Alert color="primary" className="!px-8 !py-4">
                <span className="text-md font-semibold">{children}</span>
            </Alert>
        </div>
    );
};
